import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
})
export class LoaderComponent {
    @Input() text = 'Loading...';
    @Input() overlay = true;
    @Input() size: 'small' | 'medium' | 'large' = 'medium';

    get containerClasses(): { [klass: string]: boolean } {
        return {
            'app-loader': true,
            'app-loader--overlay': this.overlay,
            'app-loader--inline': !this.overlay,
        };
    }

    get spinnerClasses(): { [klass: string]: boolean } {
        return {
            'app-loader__spinner': true,
            'app-loader__spinner--small': this.size === 'small',
            'app-loader__spinner--medium': this.size === 'medium',
            'app-loader__spinner--large': this.size === 'large',
        };
    }
}
